import {get} from "lodash"

import {Deal} from "@irati/types"
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes"

const isAppOnly = (deal: Deal) => {
  return get(deal, "typeHighlight") === DealHighlightTypes.APP_ONLY
}

export default isAppOnly
